module.exports = __webpack_public_path__ + "static/img/Bachelor_010854.51610d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010854.jpg
// module id = 262
// module chunks = 0